export default {
    update: 'Atualização',
    urlTerms: 'termos',
    acceptTerms: 'Aceitar os termos',
    terms: 'Termos de uso do Astrolink',
    onAccept: 'Ao tocar em "Aceitar os termos" você se declara ciente e de acordo com as atualizações para seu acesso a partir da data de alteração.',

    paragraph: {
        '1': `Nossos <a href="/termos">Termos de uso</a> estão sendo atualizados 
              visando entregar uma experiência mais segura e completa para os usuários do Astrolink.`,
             
        '2': `Os novos <a href="/termos">Termos de uso</a> e suas alterações passam a valer a partir 
              de <strong>{date}</strong>. Nós encorajamos a leitura do documento na íntegra a partir dos links deste 
              comunicado, você deverá aceitar os novos termos para continuar usando o Astrolink.`
    }
};
